exports.components = {
  "component---src-page-templates-dynamic-tsx": () => import("./../../../src/pageTemplates/dynamic.tsx" /* webpackChunkName: "component---src-page-templates-dynamic-tsx" */),
  "component---src-page-templates-extra-tsx": () => import("./../../../src/pageTemplates/extra.tsx" /* webpackChunkName: "component---src-page-templates-extra-tsx" */)
}

